import {PollRobotTemplate} from './PollRobotTemplate.js'

export class AnswerOption {
	constructor(parent, answerModel, questionModel,optionModel) {
		this.parent = parent;
		this.answerModel = answerModel;
		this.questionModel = questionModel;
		this.optionModel = optionModel;
		
		[this.el, this.$] = PollRobotTemplate(`AnswerOption`);
		this.$.text.innerText = optionModel.text;
		parent.appendChild(this.el);

		this.el.addEventListener(`click`, evt=>{
			this.click(evt);
		});
		
		this.selected = false;
		this.answerModel.addListener(this);
		// parent.addEventListener(`pollrobot-option-selected`, evt=>{
		// 	this.option_selected(evt.detail);
		// });
	}
	click(evt) {
		evt.preventDefault(); evt.stopPropagation();
		this.answerModel.setOption(this.questionModel.id, this.optionModel.id, !this.selected);
		// this.parent.dispatchEvent(new CustomEvent(`pollrobot-option-selected`, {
		// 	bubbles: false,
		// 	detail: this,
		// }));
	}
	answer_option_changed(option_id, value) {
		if (option_id!=this.optionModel.id) {
			return
		}
		if (true===value && !this.selected) {
			this.selected = true;
			this.el.classList.add(`selected`);
		} else {
			if (this.selected) {
				this.selected = false;
				this.el.classList.remove(`selected`);
			}
		}
	}
	// option_selected(option) {
	// 	if (option==this) {
	// 		this.el.classList.toggle(`selected`);
	// 		this.selected = !this.selected;
	// 	} else {
	// 		if (this.questionModel.isSingleSelectType()) {
	// 			// ONLY IF QUESTION IS SINGLE-SELECT
	// 			this.el.classList.remove(`selected`);
	// 			this.selected = false;
	// 		}
	// 	}
	// }
}